import { gsap, ScrollTrigger, Power4, Power2 } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";


gsap.registerPlugin(ScrollTrigger);

const loader = (callback) => {
    const loaderText = document.querySelectorAll(".loader .loading-number");

    const loaderTl = gsap.timeline({
        paused: true
    });

    const text = new SplitText(".main  h1 span , .header .logo , .header .menu li a, .header .search", { type: "chars" });

    gsap.set(".main  h1 span > div, .header .logo , .header .menu li a > div, .header .search > div", {
        opacity: 0,
        y: 15
    });

    if($(window).width() < 767) {
        gsap.set(".header .menu li a > div", {
            opacity: 1,
            y: 0
        });
    }

    loaderText[0].textContent = 100;
    gsap.from(loaderText, {
        textContent: 0,
        duration: 3,
        ease: Power4.easeInOut,
        snap: { textContent: 1 },
        onComplete: () => {
            gsap.delayedCall(0.5, startLoaderExitAnimation);
        },
    });

    const startLoaderExitAnimation = () => {
        loaderTl.to('.loading-number', {
            autoAlpha: 0,
            duration: 1,
            ease: Power2.easeInOut
        }).set(".loader", {
            className: '+= loader loader-svg'
        }, 0.15).set(".loader", {
            className: "+= loader loader-svg loader-init"
        }).to('.loader svg', {
            autoAlpha: 0,
        }, 1.3).to('.loader', {
            autoAlpha: 0,
            duration: 1
        }, 2).to(".main", {
            className: '+= main active'
        }, 2.3).to(".header .logo", {
            autoAlpha: 1,
            y: 0
        }, 2.6).to(text.chars, {
            autoAlpha: 1,
            y: 0,
            stagger: 0.015
        }).call(removeLoader);
    };

    function removeLoader() {
        $(".loader").remove();
        if (callback) callback();
    }

    

    loaderTl.play();
};

export default loader;